import { Operation } from "constants/serviceWorker";
import BaseCustomGetResponse from "./BaseCustomGetResponse";
import { iCachedItem } from "interfaces/models/serviceWorker";
import { CreateInspectionTypeRes } from "apiClient/v2/inspection/inspectionTypeApi";

class CustomResponseInspectionType extends BaseCustomGetResponse {
  // for list inspection type and inspection content
  defaultNumberRequestRelative = 2;

  filterCachedItem(args: { cachedItem: iCachedItem; validParams: string[] }) {
    const {
      cachedItem: { operation, ...item },
      validParams,
    } = args;
    // with case update -> only cache some field update -> can ignore verify params
    if (operation === Operation.Patch) {
      return true;
    }
    if (operation === Operation.Delete) {
      return !(
        validParams.includes("isDeleted") && this.params["isDeleted"] === "true"
      );
    }
    const checkValidParams = validParams.every((key) => {
      const itemDataKey = key;
      let itemData = (item.data as any)[itemDataKey];
      const paramsKey = key;
      const paramsData = decodeURIComponent(this.params[paramsKey]);
      if (paramsKey === "isDeleted") {
        itemData = (item.data as any)[itemDataKey] ?? "false";
        // same as above
      } else if (["page", "total", "paging"].includes(paramsKey)) {
        itemData = paramsData;
      }
      if (key === "bimFileId" && operation === Operation.Post) {
        itemData = (item.data as CreateInspectionTypeRes)?.inspectionType
          ?.bimFileId;
      }

      return paramsData === itemData;
    });

    return checkValidParams;
  }

  getCachedData(cachedItem: iCachedItem) {
    const cachedData = cachedItem.data;
    if (cachedItem.operation === Operation.Post) {
      return (cachedData as CreateInspectionTypeRes).inspectionType;
    }

    return cachedData;
  }
}

export default CustomResponseInspectionType;
